// extracted by css-extract-rspack-plugin
export default {"fieldWidth":"YcWrKdBy6s4wwmaE"};